import Dataset from "./Dataset";

export default class Sections extends Dataset {
  type = "feature";
}
